import { FormatProps } from "../../../../../domain/entities/table-formats";
import React from "react";
import { Tooltip } from "../../tooltip";
import { useUTCDate } from "../../../hooks/use-utc-date";

const CurrencyFormat = ({ data }: FormatProps): React.ReactElement => (
  <span>
    {data === 0 || data
      ? new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 0,
        }).format(data as number)
      : "- -"}{" "}
    USD
  </span>
);

const DateFormat = ({
  data,
  format,
  style,
}: FormatProps): React.ReactElement => {
  const { dateFromUTC } = useUTCDate();

  return (
    <span style={style}>
      {data ? dateFromUTC(data as string).format(format) : "- -"}
    </span>
  );
};

const TextFormat = ({ data }: FormatProps): React.ReactElement => (
  <Tooltip text={data as string}>
    <span className="w-full overflow-hidden text-ellipsis whitespace-nowrap">
      {data && `${data || ""}`}
    </span>
  </Tooltip>
);

export { CurrencyFormat, DateFormat, TextFormat };
